/**
 * Lead-Reaktionszeit (Jul-2026, User-Wunsch): Wochenübersicht je Verkäufer —
 * Ø-Reaktionszeit auf zugeteilte Leads (letzte 7 Tage).
 * Datenquelle: GET /api/dealer/leads/performance-report?days=7
 */
import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import api from "../../lib/api";

const fmtH = (h) => {
    if (h == null) return "—";
    if (h < 1) return `${Math.round(h * 60)} Min`;
    return `${String(Math.round(h * 10) / 10).replace(".", ",")} Std`;
};

const reactionColor = (h) => {
    if (h == null) return "text-gray-400";
    if (h < 2) return "text-emerald-600";
    if (h < 4) return "text-amber-600";
    return "text-red-600";
};

export default function LeadReactionCard() {
    const [sellers, setSellers] = useState(null);

    useEffect(() => {
        api.get("/dealer/leads/performance-report", { params: { days: 7 } })
            .then((r) => setSellers(r.data?.sellers || []))
            .catch(() => setSellers([]));
    }, []);

    if (!sellers) return null;

    return (
        <div className="bg-white border border-gray-200 rounded-sm p-3" data-testid="lead-reaction-card">
            <div className="flex items-center gap-1.5 mb-2">
                <Timer className="w-3.5 h-3.5 text-amber-500" />
                <div className="text-[10px] uppercase tracking-wider font-bold text-gray-600">Lead-Reaktionszeit — letzte 7 Tage</div>
            </div>
            {sellers.length === 0 ? (
                <p className="text-[11px] text-gray-500" data-testid="lead-reaction-empty">
                    Keine zugeteilten Leads in den letzten 7 Tagen.
                </p>
            ) : (
                <table className="w-full text-[11px]">
                    <thead>
                        <tr className="text-left text-[10px] uppercase tracking-wider text-gray-400">
                            <th className="pb-1 font-bold">Verkäufer</th>
                            <th className="pb-1 font-bold text-right">Ø Reaktion</th>
                            <th className="pb-1 font-bold text-right">Leads</th>
                            <th className="pb-1 font-bold text-right">Kontaktiert</th>
                            <th className="pb-1 font-bold text-right">Offen</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {sellers.map((s) => (
                            <tr key={s.seller_id} data-testid={`lead-reaction-row-${s.seller_id}`}>
                                <td className="py-1 font-bold text-gray-800 truncate max-w-[140px]">{s.seller_name}</td>
                                <td className={`py-1 text-right font-black ${reactionColor(s.avg_reaction_h)}`}>{fmtH(s.avg_reaction_h)}</td>
                                <td className="py-1 text-right text-gray-700">{s.leads}</td>
                                <td className="py-1 text-right text-gray-700">{s.contacted}</td>
                                <td className={`py-1 text-right font-bold ${s.open > 0 ? "text-amber-600" : "text-gray-400"}`}>{s.open}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            <p className="mt-2 text-[10px] text-gray-400">
                Ampel: <span className="text-emerald-600 font-bold">&lt; 2 Std</span> · <span className="text-amber-600 font-bold">2–4 Std</span> · <span className="text-red-600 font-bold">&gt; 4 Std</span> — Filialleiter werden nach 2 Std ohne Erstkontakt automatisch benachrichtigt.
            </p>
        </div>
    );
}
